module.exports = __webpack_public_path__ + "media/bgm_zhuanbei.d74d0266.mp3";